var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3611 0.546332C13.6628 0.244601 14.152 0.244601 14.4537 0.546332C14.7555 0.848063 14.7555 1.33726 14.4537 1.639L7.50007 8.59266C7.19834 8.89439 6.70914 8.89439 6.40741 8.59266C6.10568 8.29093 6.10568 7.80173 6.40741 7.5L13.3611 0.546332Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1348 1.86533H10.0443C9.61759 1.86533 9.27167 1.51941 9.27167 1.0927C9.27167 0.665986 9.61759 0.320068 10.0443 0.320068H13.9074C14.3342 0.320068 14.6801 0.665986 14.6801 1.0927V4.95585C14.6801 5.38256 14.3342 5.72848 13.9074 5.72848C13.4807 5.72848 13.1348 5.38256 13.1348 4.95585V1.86533Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5894 8.43259C11.5894 8.00588 11.9354 7.65996 12.3621 7.65996C12.7888 7.65996 13.1347 8.00588 13.1347 8.43259V12.7786C13.1347 14.0054 12.1402 14.9999 10.9134 14.9999H2.22131C0.994514 14.9999 0 14.0054 0 12.7786L1.84209e-06 4.08654C1.84209e-06 2.85975 0.994516 1.86523 2.22131 1.86523C5.33651 1.86524 5.33651 1.86524 6.92953 1.86524C7.35624 1.86524 7.70216 2.21116 7.70216 2.63787C7.70216 3.06458 7.35624 3.4105 6.92953 3.4105C5.33651 3.4105 5.33651 3.4105 2.22131 3.41049C1.84794 3.41049 1.54526 3.71317 1.54526 4.08654L1.54526 12.7786C1.54526 13.152 1.84794 13.4547 2.22131 13.4547H10.9134C11.2868 13.4547 11.5894 13.152 11.5894 12.7786V8.43259Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c13bb6290211f932339daac1ff4e3dfa.svg";
export { ForwardRef as ReactComponent };